import { isEmpty, isNumber, isString, isNaN } from 'lodash';

export const isNumeric = (strOrNum: string | number): boolean => {
  let num = strOrNum;
  if (isString(strOrNum) && !isEmpty(strOrNum)) num = Number(strOrNum);

  return isNumber(num) && !isNaN(num);
};
